import React, { Component } from 'react';
import { TextOnly } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './style.css';

/**
 * The about us section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class GetInTouchView extends Component {
	render () {
		const { content, heading } =
			this.props.content.landingPage.getInTouch;
		return (
			<TextOnly
				className='GetInTouch'
				{...{
					content,
					heading,
				}}
			/>
		);
	}
}

export default withLanguageContext(GetInTouchView);



// WEBPACK FOOTER //
// ./src/components/views/GetInTouchView/GetInTouchView.js